import React from 'react';
import './logo.styl';
//images
//import logoTextPos from '../../media/logotext-pos.png';
import logoTextNeg from '../../media/logotext-neg.png';
import logoTextPos from '../../media/logotext-pos.png';
import logosmall from '../../media/logosmall.png';

class Logo extends React.Component {

  render(){
    let logo;
    //check props
    if(this.props.ver === 'unfolded'){
      if(this.props.neg){
        logo = logoTextNeg;
      }
      else{
        logo = logoTextPos;
      }
    }
    else if(this.props.ver === 'folded'){
      logo = logosmall;
    }

    return (
        <img className={ "logo " + this.props.size }  src={logo} alt='aircheckr-logo' />
    );
  }
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/logo/Logo.js